var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.5H14.5C13.4 10.5 12.51 11.4 12.51 12.5L12.5 28.5C12.5 29.6 13.39 30.5 14.49 30.5H26.5C27.6 30.5 28.5 29.6 28.5 28.5V16.5L22.5 10.5ZM26.5 28.5H14.5V12.5H21.5V17.5H26.5V28.5ZM16.5 23.51L17.91 24.92L19.5 23.34V27.5H21.5V23.34L23.09 24.93L24.5 23.51L20.51 19.5L16.5 23.51Z",
    fill: "#2D6CDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2367f19c20fb3ae79f8049d1ffb6eeb1.svg";
export { ForwardRef as ReactComponent };